import { render, staticRenderFns } from "./OrmUtilitiesDetail.vue?vue&type=template&id=0c598b56&scoped=true"
import script from "./OrmUtilitiesDetail.vue?vue&type=script&lang=js"
export * from "./OrmUtilitiesDetail.vue?vue&type=script&lang=js"
import style0 from "./OrmUtilitiesDetail.vue?vue&type=style&index=0&id=0c598b56&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c598b56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c598b56')) {
      api.createRecord('0c598b56', component.options)
    } else {
      api.reload('0c598b56', component.options)
    }
    module.hot.accept("./OrmUtilitiesDetail.vue?vue&type=template&id=0c598b56&scoped=true", function () {
      api.rerender('0c598b56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/utilities/orm/OrmUtilitiesDetail.vue"
export default component.exports